import { useState } from 'react';
import { ChevronRight } from 'lucide-react';

interface CollapsibleSectionProps {
  title: string;
  icon: React.ElementType;
  count?: number;
  defaultOpen?: boolean;
  children: React.ReactNode;
  badge?: React.ReactNode;
}

export function CollapsibleSection({ title, icon: Icon, count, defaultOpen = false, children, badge }: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-b border-[rgba(55,53,47,0.06)] dark:border-white/6">
      <button onClick={() => setOpen(v => !v)} className="flex items-center gap-2 w-full px-3.5 py-2 hover:bg-[rgba(55,53,47,0.03)] dark:hover:bg-white/[0.03] transition-colors group">
        <ChevronRight className={`w-3 h-3 text-[#6F6E69] transition-transform duration-150 ${open ? 'rotate-90' : ''}`} />
        <Icon className="w-3.5 h-3.5 text-[#6F6E69] group-hover:text-[#6F6E69] transition-colors" />
        <span className="text-[11px] font-medium text-[#37352F] dark:text-white/90 flex-1 text-left">{title}</span>
        {count !== undefined && count > 0 && (
          <span className="text-[10px] text-[#6F6E69] tabular-nums">{count}</span>
        )}
        {badge}
      </button>
      <div
        className="overflow-hidden transition-all duration-150 ease-out"
        style={{ maxHeight: open ? '2000px' : '0px', opacity: open ? 1 : 0 }}
      >
        <div className="px-3.5 pb-3">{children}</div>
      </div>
    </div>
  );
}
